module.exports = __webpack_public_path__ + "static/media/firmness.d23e1cd6.svg";